/**
 * 「先頭 1 名 + 他 N 名 + tooltip 全名」 表示ロジックの共通 pure 関数 (spec
 * AC-WFW-001「対応者」 列 / AC-WFW-005c サブステップ担当者表示、 issue #4550
 * multi-select 化の Implementation Notes)。
 *
 * 一覧 (`WorkflowCases/components/CaseTable.tsx` の対応者列) と詳細
 * (`WorkflowCaseDetail/components/SubStepRow.tsx` の担当者表示) の両方が
 * 同じ「先頭 1 名 + 他 N 名」 畳み込みを行うため、 呼び出し側で表示名解決
 * (member_id → displayName、 未解決フォールバック文言) を済ませた名前配列
 * を受け取り、 畳み込みの形だけをここで共通化する。 i18n 文言・フォールバック
 * 文言は呼び出し側の namespace に委ねる (page ごとに独立した i18n key を持つ
 * 既存パターンを踏襲)。
 */
export type MemberListDisplay = {
  /** 先頭 1 名 (names が空の場合は undefined)。 */
  lead: string | undefined
  /** 先頭を除いた残り人数 (0 なら「他 N 名」を表示しない単独表示)。 */
  othersCount: number
  /** tooltip 用の全名一覧 (names をそのまま保持。0 件なら空配列)。 */
  allNames: string[]
}

export function summarizeMemberNames(names: string[]): MemberListDisplay {
  const [lead, ...rest] = names
  return { lead, othersCount: rest.length, allNames: names }
}
